'use strict';

var defaults = require('./defaults.cjs');
var errors = require('../../../../../../motion-utils/dist/es/errors.cjs');
var timeConversion = require('../../../../../../motion-utils/dist/es/time-conversion.cjs');
var clamp = require('../../../../../../motion-utils/dist/es/clamp.cjs');

const safeMin = 0.001;
function findSpring({ duration = defaults.springDefaults.duration, bounce = defaults.springDefaults.bounce, velocity = defaults.springDefaults.velocity, mass = defaults.springDefaults.mass, }) {
    let envelope;
    let derivative;
    errors.warning(duration <= timeConversion.secondsToMilliseconds(defaults.springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp.clamp(defaults.springDefaults.minDamping, defaults.springDefaults.maxDamping, dampingRatio);
    duration = clamp.clamp(defaults.springDefaults.minDuration, defaults.springDefaults.maxDuration, timeConversion.millisecondsToSeconds(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = timeConversion.secondsToMilliseconds(duration);
    if (isNaN(undampedFreq)) {
        return {
            stiffness: defaults.springDefaults.stiffness,
            damping: defaults.springDefaults.damping,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

exports.calcAngularFreq = calcAngularFreq;
exports.findSpring = findSpring;
//# sourceMappingURL=find.cjs.map
